import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import DataPerusahaan from './modules/DataPerusahaan';
import DokumenLegal from './modules/DokumenLegal';
import Pengurus from './modules/Pengurus';
import PemegangSaham from './modules/PemegangSaham';
import DaftarPerusahaan from './modules/DaftarPerusahaan';
import ProfilWebsite from './modules/ProfilWebsite';

const menuItems = [
  { key: 'perusahaan', label: 'Data Perusahaan', icon: '🏢' },
  { key: 'dokumen', label: 'Dokumen Legal', icon: '📄' },
  { key: 'pengurus', label: 'Pengurus', icon: '👤' },
  { key: 'saham', label: 'Pemegang Saham', icon: '💰' },
  { key: 'profil', label: 'Profil Website', icon: '🌐' },
];

const superAdminMenu = [
  { key: 'daftar', label: 'Semua Perusahaan', icon: '🏛️' },
  ...menuItems,
];

export default function AdminDashboard() {
  const { user, company, logout } = useAuth();
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState(user?.role === 'super_admin' ? 'daftar' : 'perusahaan');
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  const handleLogout = () => { logout(); navigate('/admin'); };

  const menus = user?.role === 'super_admin' ? superAdminMenu : menuItems;

  const handleCompanySelect = (cid) => {
    setSelectedCompanyId(cid);
    setActiveMenu('perusahaan');
  };

  const companyId = user?.role === 'super_admin' ? selectedCompanyId : user?.company_id;

  return (
    <div style={s.layout}>
      {/* Sidebar */}
      <aside style={s.sidebar}>
        <div style={s.sidebarTop}>
          <div style={s.brand}>
            <span style={s.brandIcon}>PT GPB</span>
            <span style={s.brandText}>Portal Admin</span>
          </div>
          {company && <div style={s.companyName}>{company.nama_perusahaan}</div>}
          {user?.role === 'super_admin' && <div style={s.superBadge}>Super Admin</div>}
        </div>
        <nav style={s.nav}>
          {menus.map(m => (
            <button
              key={m.key}
              style={{ ...s.menuBtn, ...(activeMenu === m.key ? s.menuActive : {}) }}
              onClick={() => { setActiveMenu(m.key); if (m.key !== 'perusahaan' && m.key !== 'dokumen' && m.key !== 'pengurus' && m.key !== 'saham' && m.key !== 'profil') setSelectedCompanyId(null); }}
            >
              <span style={s.menuIcon}>{m.icon}</span>
              {m.label}
            </button>
          ))}
        </nav>
        <div style={s.sidebarBottom}>
          <div style={s.userInfo}>👤 {user?.username}</div>
          <button style={s.logoutBtn} onClick={handleLogout}>Keluar</button>
        </div>
      </aside>

      {/* Main Content */}
      <main style={s.main}>
        {activeMenu === 'daftar' && <DaftarPerusahaan onSelectCompany={handleCompanySelect} />}
        {activeMenu === 'perusahaan' && <DataPerusahaan companyId={companyId} />}
        {activeMenu === 'dokumen' && <DokumenLegal companyId={companyId} />}
        {activeMenu === 'pengurus' && <Pengurus companyId={companyId} />}
        {activeMenu === 'saham' && <PemegangSaham companyId={companyId} />}
        {activeMenu === 'profil' && <ProfilWebsite companyId={companyId} />}
      </main>
    </div>
  );
}

const s = {
  layout: { display: 'flex', minHeight: '100vh', fontFamily: "'Inter', sans-serif", background: '#f5f7fa' },
  sidebar: { width: '240px', minWidth: '240px', background: 'linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)', color: 'white', display: 'flex', flexDirection: 'column', position: 'fixed', top: 0, left: 0, height: '100vh', zIndex: 100 },
  sidebarTop: { padding: '24px 16px 16px' },
  brand: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' },
  brandIcon: { background: 'rgba(255,255,255,0.15)', borderRadius: '8px', padding: '6px 8px', fontSize: '11px', fontWeight: 'bold', letterSpacing: '0.5px' },
  brandText: { fontSize: '14px', fontWeight: '600', color: 'white' },
  companyName: { fontSize: '12px', color: 'rgba(255,255,255,0.6)', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: '8px', lineHeight: 1.4 },
  superBadge: { background: 'rgba(234,179,8,0.2)', color: '#fbbf24', borderRadius: '6px', padding: '3px 8px', fontSize: '11px', fontWeight: '600', display: 'inline-block', marginBottom: '4px' },
  nav: { flex: 1, padding: '8px 12px' },
  menuBtn: { display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '10px 12px', background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.7)', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', textAlign: 'left', marginBottom: '4px', transition: 'all 0.2s' },
  menuActive: { background: 'rgba(255,255,255,0.15)', color: 'white' },
  menuIcon: { fontSize: '16px' },
  sidebarBottom: { padding: '16px' },
  userInfo: { fontSize: '12px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px' },
  logoutBtn: { width: '100%', padding: '8px', background: 'rgba(239,68,68,0.2)', color: '#fca5a5', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  main: { flex: 1, marginLeft: '240px', padding: '24px', minHeight: '100vh' },
};
